// import { useMutation, useQueryClient } from '@tanstack/react-query';
// import { sellerServices } from '../services/seller.service';
// import { toast } from 'sonner'; // swap with your toast lib if different

// const parseApiError = (error) => {
//   const message =
//     error?.response?.data?.error ||
//     error?.response?.data?.message ||
//     error?.message ||
//     'Something went wrong';

//   return new Error(message); // ← throw a real Error, not a plain object
// };

// export const useUpdateSellerProfile = () => {
//   const queryClient = useQueryClient();

//   return useMutation({
//   mutationFn: async ({ sellerId, updates }) => {
//   try {
//     return await sellerServices.updateSellerProfile({
//       sellerId,
//       ...updates,
//     });
//   } catch (error) {
//     console.log('AXIOS ERROR:', error);
//     console.log('RESPONSE:', error?.response?.data);

//     throw parseApiError(error);
//   }
// },

// onError: (error) => {
//   console.log('REACT QUERY ERROR:', error);
//   toast.error(error?.message || 'Failed to update seller profile');
// },

//     onSuccess: () => {
//       queryClient.invalidateQueries({ queryKey: ['sellers'] });
//       toast.success('Seller profile updated successfully');
//     },

//     onError: (error) => {
//       toast.error(error?.message || 'Failed to update seller profile');
//     },
//   });
// };


import { useMutation, useQueryClient } from '@tanstack/react-query';
import { sellerServices } from '../services/seller.service';
// import { toast } from 'sonner';
import { toast } from 'react-hot-toast';


const parseApiError = (error) => {
  const message =
    error?.response?.data?.error ||
    error?.response?.data?.message ||
    error?.message ||
    'Something went wrong';

  return new Error(message);
};

export const useUpdateSellerProfile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ sellerId, updates }) => {
      try {
        return await sellerServices.updateSellerProfile({
          sellerId,
          ...updates,
        });
      } catch (error) {

         console.log('1. RAW AXIOS ERROR:', error);
    console.log('2. RESPONSE DATA:', error?.response?.data);
    const parsed = parseApiError(error);
    console.log('3. PARSED ERROR:', parsed);
    console.log('4. IS ERROR INSTANCE:', parsed instanceof Error);
    throw parsed;
        // throw parseApiError(error);
      }
    },

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sellers'] });
      toast.success('Seller profile updated successfully');
    },

    onError: (error) => {

        console.log('5. ON ERROR FIRED:', error);

      toast.error(error?.message || 'Failed to update seller profile');
    },
  });
};